import { gql } from '@apollo/client';

import { BREAKDOWN_FIELDS } from './breakdownFragment';

export const FETCH_RIDES_WITH_FILTERS = gql`
	query rideSearchWithFilters($pagination: PaginationInput!, $filter: RideSearchFilter!) {
		rideSearch(pagination: $pagination, filter: $filter) {
			results {
				id
				tripNumber
				departure
				lineCode
				status
				stations {
					id
					code
					name
					timezone
					arrival
					departure
				}
				workAssignmentSequences {
					sequenceGroupId
					crewMember {
						id
						fullName
					}
					fromStation {
						id
						name
					}
					fromTimestamp
					toStation {
						id
						name
					}
					toTimestamp
					status
					activityType
					isMultiRide
					extraActivities {
						id
						activityType
						fromStation {
							id
							code
						}
						toStation {
							id
							code
						}
						fromTimestamp
						toTimestamp
					}
					job {
						id
						code
					}
					run {
						id
						name
					}
					breakdown {
						...BreakdownFields
					}
				}
				vehicleAssignments {
					mobilityPartnerName
					plateNumber
					busNumber
					vehicleType
				}
				runs {
					id
					name
				}
				jobs {
					id
					code
				}
			}
			page {
				page
				size
				totalPages
				totalCount
			}
		}
	}
	${BREAKDOWN_FIELDS}
`;
